export default (context, background) => {
    document.getElementById('add-text-page__textarea').focus();
    context.textColor = background
    context.text_click_close_colors(context)
}